import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import axios from "axios";
import { SERVICE_LOCATION, GET_JOBS_FOR_INVOICING, DOWNLOAD_WORKCARD_DETAILS_BY_MEASUREIDs } from "../constants/endpoints";
import { WORKCARDS_DOWNLOADED } from "./../constants/errors";

import "./../assets/styles/table.css";
import "./../assets/styles/fitter.css";
import "./../assets/styles/reports.css";

const PrintFinanceReport = (props) => {
    const toast = useRef(null);

    const [worksheets, setWorksheets] = useState(null);
    const [selectedWorksheets, setselectedWorksheets] = useState(null);
    const [filteredWorksheets, setFilteredWorksheets] = useState(null);
    const [selectedStartDate, setSelectedStartDate] = useState(null);
    const [selectedEndDate, setSelectedEndDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const [showUnsubmittedData, setShowUnsubmittedData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [disableSubmitButton, setDisableSubmitButton] = useState(true);
    const [disableDownloadButton, setDisableDownloadButton] = useState(true);

    const { data } = props;
    const userDepot = (data !== undefined && data !== null) ? data.data.userDetails.depot : "";

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    useEffect(() => {
        initFilters();
    }, []);

    const getWorksheets = () => {
        setLoading(true);
        clearFilter();
        const startDate = getFormattedDate(selectedStartDate);
        const endDate = getFormattedDate(selectedEndDate);
        const requestedData = {
            StartDate: startDate,
            EndDate: endDate,
            Depot: userDepot
        }

        const endPoint = SERVICE_LOCATION + GET_JOBS_FOR_INVOICING;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                setDisableDownloadButton(true);
                setselectedWorksheets(null);
                if (response.data.isSuccess) {
                    const processedData = response.data.data.jobDetails;
                    setWorksheets(processedData);
                    setFilteredWorksheets(processedData);
                }
                else if (!response.data.isSuccess) {
                    setWorksheets(null);
                    setFilteredWorksheets(null);
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    };

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const handleStartDateChange = (e) => {
        const dateSelected = e.value;
        setSelectedStartDate(dateSelected);
        setMinDate(dateSelected);
        setSelectedEndDate(null);
        setDisableSubmitButton(true);
    }

    const handleEndDateChange = (e) => {
        const dateSelected = e.value;
        setSelectedEndDate(dateSelected);
        setDisableSubmitButton(false);
    }

    const handleWorksheetSelection = (e) => {
        // // Restricting multiple customers
        // const distinctClientNames = new Set((e.value).map((item) => item.clientName));
        // if (distinctClientNames.size <= 1) {
        //     setselectedWorksheets(e.value);  
        //     e.value.length > 0 ? setDisableDownloadButton(false) : setDisableDownloadButton(true);
        // }         
        // else {
        //     toast.current.show({ severity: "error", summary: "Error", detail: "Please choose measures for a single customer.", life: 5000 });
        // }

        setselectedWorksheets(e.value);
        e.value.length > 0 ? setDisableDownloadButton(false) : setDisableDownloadButton(true);
    }

    const downloadWorksheets = () => {
        getWorksheets();
        setShowUnsubmittedData(true);
    }

    const getFilteredWorksheets = (filteredData) => {
        setFilteredWorksheets(filteredData);
    }

    const handlePDFDownload = () => {
        setLoading(true);
        var selectedMeasureIds = [];
        selectedWorksheets.forEach(worksheet => {
            const measureIds = {
                measureId: worksheet.measureId
            }
            selectedMeasureIds.push(measureIds);
        })
        const endPoint = SERVICE_LOCATION + DOWNLOAD_WORKCARD_DETAILS_BY_MEASUREIDs;
        axios.post(endPoint, selectedMeasureIds, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                if (response.data.isSuccess) {
                    if (response.data.data.downloadedWorkCards.length > 0) {
                        (response.data.data.downloadedWorkCards).forEach(workcard => {
                            const base64 = workcard.chunks.join("");
                            const base64String = "data:application/pdf;base64," + base64;
                            const linkSource = base64String;
                            const downloadLink = document.createElement("a");
                            const fileName = workcard.fileName;
                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                        });
                    }
                    toast.current.show({ severity: "success", summary: "Success", detail: WORKCARDS_DOWNLOADED, life: 5000 });
                }
                else if (!response.data.isSuccess) {
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 5000 });
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 5000 });
            })
    }

    //export functionality
    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                let EXCEL_EXTENSION = ".xlsx";
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

    const exportExcel = () => {
        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(filteredWorksheets);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            saveAsExcelFile(excelBuffer, "worksheets");
        });
    };

    // Staus severity with colors for submission status
    const getStatusSeverity = (submissionStatus) => {
        switch (submissionStatus) {
            case "Approved":
                return "approve";
            case "Site Attention":
                return "attention";
            case "Site Revisit":
                return "revisit";
            case "Pending":
                return "pending";
            default:
                return "nocolor";
        }
    };

    const statusBodyTemplate = (worksheet) => {
        return <span className={`status-severity ${getStatusSeverity(worksheet.submissionStatus)}`}>{worksheet.submissionStatus}</span>
    };

    // Staus severity with colors for submission status ends here

    // Search functionality
    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            paymentFormRequired: { value: null, matchMode: FilterMatchMode.EQUALS },
            siteName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteAddress: { value: null, matchMode: FilterMatchMode.CONTAINS },
            siteTelNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plotNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plotDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            worksheetNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureDescription: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            planDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
            depot: { value: null, matchMode: FilterMatchMode.CONTAINS },
            submissionStatus: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue("");
    }

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <div className="flex align-items-center justify-content-end gap-2">
                        <Button className="mar-r-10" type="button" icon="pi pi-file-excel" severity="success" onClick={exportExcel} rounded tooltip="Export Excel Report" />
                    </div>
                </div>
                <div className="col-12 col-sm-8 col-md-8 col-lg-8 col-xl-8">
                    <div className="flex justify-content-end txt-right">
                        <Button className="btn-secondary mar-r-10" onClick={handlePDFDownload} disabled={disableDownloadButton}>Download Worksheet(s) PDF</Button>
                        <Button className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>

            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    // Search functionality Ends here    

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }

            <Toast ref={toast} />
            <div className="worksheets-section padl-20">
                <h4>Worksheets</h4>
                <div className="row pad-tb-10">
                    <div className="col-3">
                        <label htmlFor="start-date">Start Date</label>
                        <Calendar id="start-date" name="start-date" value={selectedStartDate} onChange={handleStartDateChange} showIcon dateFormat="dd/mm/yy" />
                    </div>
                    <div className="col-3">
                        <label htmlFor="end-date">End Date</label>
                        <Calendar id="end-date" name="end-date" value={selectedEndDate} minDate={minDate} onChange={handleEndDateChange} showIcon dateFormat="dd/mm/yy" />
                    </div>
                    <div className="col-3">
                        <Button id="submit" label="Submit" disabled={disableSubmitButton} onClick={downloadWorksheets} />
                    </div>
                </div>

                <div>
                    {
                        showUnsubmittedData &&
                        <div className="row">
                            <div className="col-12">
                                <DataTable className="font-12" value={worksheets} dataKey="measureId" paginator selection={selectedWorksheets} selectionMode="checkbox"
                                    onSelectionChange={handleWorksheetSelection} rows={10} removableSort sortMode="multiple"
                                    rowsPerPageOptions={[10, 25, 50]} filters={filters} header={header} filterDisplay="row" onValueChange={getFilteredWorksheets}
                                    globalFilterFields={["clientAccount", "clientName", "clientAddress", "clientTerms", "paymentFormRequired",
                                        "contractNumber", "specialNotes", "siteRefNumber", "siteName", "siteAddress", "siteTelNo", "plotID", "plotNumber", "plotDescription",
                                        "worksheetNo", "worksheetCode", "measureId", "measureStatus", "measureQuantity", "measureCode", "measureDescription",
                                        "measureType", "planDate", "depot", "depotCode", "submissionId",
                                        "submissionType", "submissionStatus", "submittedBy", "submittedDate"]}
                                    scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No worksheets availabe for the selected date range.">
                                    <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
                                    <Column field="submissionStatus" header="Submission Status" sortable body={statusBodyTemplate} filter filterPlaceholder="Search by status" className="table-header"></Column>
                                    <Column field="clientAccount" header="Client Account" className="table-header" hidden></Column>
                                    <Column field="clientName" key="clientName" sortable header="Client Name" filter filterPlaceholder="Search by client name" className="table-header" ></Column>
                                    <Column field="clientAddress" header="Client Address" className="table-header" hidden></Column>
                                    <Column field="clientTerms" header="Client Terms" className="table-header" hidden></Column>
                                    <Column field="paymentFormRequired" sortable header="PaymentForm Required" className="table-header" filter filterPlaceholder="Search by Yes/No"></Column>
                                    <Column field="contractNumber" header="Contract Number" className="table-header" hidden></Column>
                                    <Column field="specialNotes" header="Special Notes" className="table-header" hidden></Column>
                                    <Column field="siteRefNumber" header="Site Ref Number" className="table-header" hidden></Column>
                                    <Column field="siteName" header="Site Name" sortable filter filterPlaceholder="Search by site name" className="table-header"></Column>
                                    <Column field="siteAddress" header="Site Address" sortable filter filterPlaceholder="Search by site address" className="table-header"></Column>
                                    <Column field="siteTelNo" header="Site Telephone No" filter filterPlaceholder="Search by telephone" className="table-header"></Column>
                                    <Column field="plotID" header="Plot ID" className="table-header" hidden></Column>
                                    <Column field="plotNumber" header="Plot Number" sortable filter filterPlaceholder="Search by plot number" className="table-header"></Column>
                                    <Column field="plotDescription" header="Plot Description" filter filterPlaceholder="Search by plot description" className="table-header"></Column>
                                    <Column field="worksheetNo" header="Worksheet No" sortable filter filterPlaceholder="Search by worksheet no" className="table-header"></Column>
                                    <Column field="worksheetCode" header="Worksheet Code" filter filterPlaceholder="Search by worksheet code" className="table-header" hidden></Column>
                                    <Column field="measureId" header="Measure Id" filter filterPlaceholder="Search by measure id" className="table-header" hidden></Column>
                                    <Column field="measureStatus" header="Measure Status" sortable filter filterPlaceholder="Search by measure status" className="table-header"></Column>
                                    <Column field="measureQuantity" header="Measure Quantity" className="table-header" hidden></Column>
                                    <Column field="measureCode" header="Measure Code" sortable filter filterPlaceholder="Search by measure code" className="table-header"></Column>
                                    <Column field="measureDescription" header="Measure Description" filter filterPlaceholder="Search by measure description" className="table-header"></Column>
                                    <Column field="measureType" header="Measure Type" sortable filter filterPlaceholder="Search by measure type" className="table-header"></Column>
                                    <Column field="planDate" header="Planed Date" sortable filter filterPlaceholder="Search by plan date" className="table-header"></Column>
                                    <Column field="depot" header="Depot" sortable filter filterPlaceholder="Search by depot" className="table-header"></Column>
                                    <Column field="depotCode" header="Depot Code" className="table-header" hidden></Column>
                                    <Column field="submissionId" header="Submission Id" className="table-header" hidden></Column>
                                    <Column field="submissionType" header="Submission Type" className="table-header" hidden></Column>
                                    <Column field="submittedBy" header="Submitted By" className="table-header" hidden></Column>
                                    <Column field="submittedDate" header="Submitted Date" className="table-header" hidden></Column>
                                </DataTable>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default PrintFinanceReport;